
import Vue from "vue";
import { FMessageBox } from "@fkui/vue";
export default Vue.extend({
    name: "AnonymMessageBox",
    components: {
        FMessageBox,
    },
});
